import { render, staticRenderFns } from "./AccountCreation.vue?vue&type=template&id=31974ac8&scoped=true&"
import script from "./AccountCreation.vue?vue&type=script&lang=js&"
export * from "./AccountCreation.vue?vue&type=script&lang=js&"
import style0 from "./AccountCreation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AccountCreation.vue?vue&type=style&index=1&id=31974ac8&scoped=true&lang=css&"
import style2 from "./AccountCreation.vue?vue&type=style&index=2&lang=css&"
import style3 from "./AccountCreation.vue?vue&type=style&index=3&lang=scss&"
import style4 from "./AccountCreation.vue?vue&type=style&index=4&id=31974ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31974ac8",
  null
  
)

export default component.exports